import { STATIC_IMAGE_BASE } from '@mc/constants'
import Image from 'components/LegacyImage'

const svgUrl = (name: string, shade: 'dark' | 'light') =>
  `${STATIC_IMAGE_BASE}/sessions/hiw/${name}-${shade}.svg`

type GenericIconProps = {
  name: string
  dark?: boolean
  width: number
  height: number
}

export type IconProps = Omit<GenericIconProps, 'name'>

export const HowItWorksIcon = ({
  name,
  dark = false,
  ...restProps
}: GenericIconProps) => (
  <Image {...restProps} alt='' src={svgUrl(name, dark ? 'dark' : 'light')} />
)
